import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Button } from '@mui/material';
import _ from 'lodash';
import api from '../utils/functions/api';

function PaymentTransactionResult() {
  const navigate = useNavigate();
  const { token } = useParams();
  const [paymentTransaction, setPaymentTransaction] = useState(null);
  const fetchPaymentTransaction = async (orderId) => {
    try {
      const { data } = await api.get(
        `${process.env.REACT_APP_API_URL}/payment-transaction/inquiry/${orderId}`,
      );
      if (_.isEmpty(data.data)) {
        navigate('/');
      }
      setPaymentTransaction(data.data);
    } catch (error) {
      navigate('/');
    }
  };

  console.log('paymentTransaction', paymentTransaction);
  useEffect(() => {
    fetchPaymentTransaction(token);
    return () => {};
  }, []);

  return (
    <div>
      <div className="my-2 ml-2">
        <div className="text-lg font-light mt-5 selection:flex items-center justify-between">
          <Link to="/">
            <Button variant="contained" color="secondary" size="small">
              <div>กลับสู่เมนูหลัก</div>
            </Button>
          </Link>

          <div />
        </div>
      </div>
      {paymentTransaction ? (
        <div className="flex w-full md:px-96">
          <div className="w-full px-2 py-4 ">
            <div className="px-6 py-6 bg-white rounded-lg border border-gray-200 shadow-md  cursor-pointer">
              <div className="flex flex-row my-2">
                <div className="text-xs w-1/2">Transaction Reference No. :</div>
                <div className="text-xs w-1/2 text-center text-zinc-400">
                  {paymentTransaction?.payment_reference_id}
                </div>
              </div>
              <div className="flex flex-row my-2">
                <div className="text-xs w-1/2">Transaction Date :</div>
                <div className="text-xs w-1/2 text-center text-zinc-400">
                  {paymentTransaction?.payment_transaction_date}
                </div>
              </div>

              <div className="flex flex-row my-2">
                <div className="text-xs w-1/2">Payment Amount (THB)</div>
                <div className="text-xs w-1/2 text-center text-zinc-400">
                  {parseFloat(
                    paymentTransaction?.total_pay_amount,
                  ).toLocaleString()}{' '}
                  บาท
                </div>
              </div>

              <div className="flex flex-row my-2">
                <div className="text-xs w-1/2">Payment Result</div>
                <div className="text-xs w-1/2 text-center">
                  {paymentTransaction?.payment_response_msg === 'Success' ? (
                    <div className="bg-green-500 hover:bg-green-600 p-1  rounded-md text-white">
                      {paymentTransaction?.payment_response_msg}
                    </div>
                  
                  ) : paymentTransaction?.payment_response_msg ? (    
                    <div >
                      {paymentTransaction?.payment_response_msg} 
                    </div>
                  ) : (
                    <div className="bg-red-500  p-1  rounded-md text-white">
                      incomplete   
                    </div>
                  )}
                </div>
              </div>

              <div className="px-1 py-1 my-6 bg-white rounded-lg border border-gray-200 shadow-md ">
                <table className="table-auto w-full ">
                  <thead className="text-xs text-center ">
                    <tr>
                      <th className="w-1/6 text-center">No.</th>
                      <th className="w-2/6 text-center">Invoice No. </th>
                      <th className="w-2/5 text-center">Grand Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentTransaction?.invoice_transactions?.map(
                      (invoice, index) => (
                        <tr
                          key={index}
                          className="text-xs text-center py-2  text-zinc-400"
                        >
                          <td>{index + 1}</td>
                          <td>{invoice.invoice_no}</td>
                          <td>
                            {(invoice.amount + invoice.vat).toLocaleString()}
                          </td>
                        </tr>
                      ),
                    )}
                  </tbody>
                </table>
              </div>

              <div />
            </div>
          </div>
        </div>
      ) : (
        <div />
      )}
    </div>
  );
}

export default PaymentTransactionResult;
